import { rem } from 'polished';
import styled from 'styled-components';

import { Badge } from '@interstate/components/Badge';
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';

export const PrimaryCardContainer = styled(Box)`
    && {
        background-color: ${({ theme }) => theme.tokens.ColorOnSurfaceInverse};
        border: ${rem(1)} solid ${({ theme }) => theme.tokens.ColorBorderMuted};
        border-radius: ${rem(4)};
        padding: ${rem(16)};
        display: flex;
        flex-direction: column;
        gap: ${rem(16)};
    }
`;

export const MetricColumnContainer = styled(Box)`
    && {
        display: flex;
        flex-direction: column;
        gap: ${rem(4)};
    }
`;

export const MetricLabel = styled(Typography)`
    && {
        color: ${({ theme }) => theme.tokens.SemColorOnSurfaceMuted};
    }
`;

export const MetricValue = styled(Typography)`
    && {
        color: ${({ theme }) => theme.tokens.SemColorOnSurfaceDefault};
    }
`;

export const PrimaryBadge = styled(Badge)`
    && {
        background-color: ${({ theme }) => theme.tokens.ColorOnSurfacePrimary};
        color: ${({ theme }) => theme.tokens.SemColorOnSurfaceInverse};
    }
`;
